import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  GetAllRolePermissionByRoleId,
  GetAllRolePermissions,
  LoginUser,
} from "../../Apis/loginApi";
import Loader from "../../Common/Loader/loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";
import ReCAPTCHA from "react-google-recaptcha";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./login.css";
import isGHMC from "../../Common/helper/helpar";

const LoginForm = ( { updateLoginPermission, setIsLoggedIn, validPaths } ) => {
  const navigate = useNavigate();
  const captchaRef = useRef( null );
  // const [captcha, setCaptcha] = useState(randomString);
  const [ enteredCaptcha, setEnteredCaptcha ] = useState( "" );
  const [ captchaError, setCaptchaError ] = useState( "" );
  const [ showPassword, setShowPassword ] = useState( false );
  const isProd = isGHMC();
  // const refreshString = () => {
  //   setCaptcha(Math.random().toString(36).slice(8));
  // };

  const [ credentials, setCredentials ] = useState( {
    emailId: "",
    password: "",
  } );
  const [ isLoading, setIsLoading ] = useState( false );

  // const handleCaptchaChange = (text) => {
  //   setCaptcha(text);
  // };

  // const handleCaptchaRefresh = () => {
  //   captchaRef.current.refresh();
  //   setInputCaptcha("");
  // };

  const handleInputChange = ( e ) => {
    const { name, value } = e.target;
    setCredentials( { ...credentials, [ name ]: value } );
  };

  const handleCaptchaChange = ( value ) => {
    setEnteredCaptcha( value ); // Store the reCAPTCHA response
  };
  const handleTogglePassword = () => {
    setShowPassword( !showPassword );
  };

  // const resetCaptcha = () => {
  //   if (captchaRef.current) {
  //     captchaRef.current.reset();
  //   }
  //   setEnteredCaptcha("");
  // };

  const resetCaptcha = () => {
    try {
      if ( captchaRef.current ) {
        captchaRef.current.reset();
      }
      setEnteredCaptcha( "" );
    } catch ( error ) {
      console.error( "Error resetting captcha:", error );
    }
  };

  // Set Cookie Token
  const setCookie = ( key, value, days ) => {
    let expires = "";
    if ( days ) {
      const date = new Date();
      date.setTime( date.getTime() + days * 24 * 60 * 60 * 1000 );
      expires = `; expires=${ date.toUTCString() }`;
    }
    // Set cookie for the root domain
    document.cookie = `${ key }=${ value || ""
      }${ expires }; domain=.vmaxtechservices.life; path=/;`;
  };

  const handleSubmit = async ( e ) => {
    e.preventDefault();
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if ( !credentials.emailId ) {
      toast.error( "Please enter your email.", {
        position: "top-right",
        autoClose: 2000,
      } );
      return;
    }

    if ( !emailPattern.test( credentials.emailId ) ) {
      toast.error( "The field EmailId has the incorrect Format.", {
        position: "top-right",
        autoClose: 2000,
      } );
      return;
    }

    if ( !credentials.password ) {
      toast.error( "Please enter your password.", {
        position: "top-right",
        autoClose: 2000,
      } );
      return;
    }
    // Check if the captcha field is empty or incorrect
    // if (enteredCaptcha === '') {
    //   setCaptchaError("Please Select the Captcha.");
    //   resetCaptcha();
    //   return; // Exit the function early if captcha is incorrect
    // } else {
    //   // Reset captcha error if it was previously set
    //   setCaptchaError("");
    // }
    // Rest of your form submission logic...
    setIsLoading( true ); // Set loading to true just before making the API call
    try {
      const loginData = {
        ...credentials,
        recaptchaResponse: enteredCaptcha,
      };
      const userData = await LoginUser( loginData );
      const token = userData;

      setCookie( "token", token, 7 );
      const role = userData.role;
      localStorage.setItem( "token", token );
      localStorage.setItem( "role", role );
      // Decode the token
      const decodedToken = jwtDecode( userData );
      const userName = decodedToken.name;
      localStorage.setItem( "userName", userName );
      // // roleIDs
      const rolePermissions = await GetAllRolePermissionByRoleId(
        decodedToken.RoleId,
        {}
      );


      localStorage.setItem( "rolePermissions", JSON.stringify( rolePermissions ) );
      const allPermissions = await GetAllRolePermissions();
      sessionStorage.setItem( "permissionsData", JSON.stringify( allPermissions ) );
      const matchedPermissions = rolePermissions.map( ( rolePerm ) => {
        const matchedPerm = allPermissions.find(
          ( perm ) => perm.permissionId === rolePerm.permissionId
        );
        return {
          ...rolePerm,
          permissionName: matchedPerm ? matchedPerm.permissionName : "zone",
          permissionCategoryName: matchedPerm
            ? matchedPerm.pageCategoryName
            : "",
        };
      } );

      const permissionNames = matchedPermissions.map(
        ( permission ) => permission.permissionName
      );

      const permissionCategoryNames = matchedPermissions.map(
        ( permission ) => permission.permissionCategoryName
      );
      localStorage.setItem( "loginPermissions", permissionNames.join( "," ) );
      localStorage.setItem(
        "permissionCategoryNames",
        permissionCategoryNames.join( "," )
      );

      //old updateLoginPermission

      // updateLoginPermission(matchedPermissions);
      // navigate("/organization-zone");
      // if (!permissionNames.includes("Zone")) {
      //   // const firstPermission = permissionNames[0]
      //   const nextPermission = findNextPermission(permissionNames)
      //     .toLowerCase()
      //     .replace(/ /g, "-");
      //   navigate(nextPermission);
      //   // navigate(firstPermission);
      // } else {
      // }

      //new updateLoginPermission
      updateLoginPermission( matchedPermissions );

      // Find valid route
      const nextPermission = findNextPermission( permissionNames );

      // Navigate safely
      navigate( nextPermission );
      const successMessage = userData.message || "LoggedIn Successfully!";
      toast.success( successMessage, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      } );
      // setSubmissionSuccess(true); // Update submission success state
    }
    catch ( error ) {
      if ( error.response && error.response.data ) {
        const { statusCode, message } = error.response.data;
        toast.error( message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        } );
      } else {
        toast.error( "An unexpected error occurred. Please try again.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
        } );
      }
    } finally {
      resetCaptcha();
      setIsLoading( false );
    }
  };

  //old findNextPermission function
  // const findNextPermission = (permissionNames) => {
  //   // Loop through the permissions and find the first one that exists in the valid paths
  //   for (const permission of permissionNames) {
  //     const formattedPermission = permission.toLowerCase().replace(/ /g, "-");
  //     if (validPaths.includes(`/${formattedPermission}`)) {
  //       return formattedPermission;
  //     }
  //   }
  //   // If no valid permission is found, return a default path
  //   return "/";
  // };

   //New findNextPermission function
  const findNextPermission = ( permissionNames ) => {
    for ( const permission of permissionNames ) {
      const formattedPermission =
        "/" + permission.toLowerCase().replace( / /g, "-" );

      // Check if route exists
      if ( validPaths.includes( formattedPermission ) ) {
        return formattedPermission;
      }
    }

    // fallback route
    return "/scv-dashboard";
  };
  return (
    <div className="main container-fluid">
      <div className="page-content1 row">
        <div
          className="l-block col-md-8"
          style={ {
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignSelf: "center",
            alignItems: "center",
          } }
        >
          <img
            src="/assets/media/image/logo-LSD.png"
          />
          <h1 className="mt-3">Lucknow Swachhata Abhiyan</h1>
        </div>
        <div className="r-block col-md-4">
          <h2>Sign in</h2>
          <form onSubmit={ handleSubmit }>
            <div className="form-group row mt-2">
              <div className="col-md-12">
                <label className="col-md-12 text-left p-0"> Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder=" Enter Your Email"
                  value={ credentials.emailId }
                  name="emailId"
                  onChange={ handleInputChange }
                  autoFocus
                  required
                />
              </div>
            </div>
            <div className="form-group">
              <div style={ { display: "flex", justifyContent: "space-between" } }>
                <label className="text-left p-0">Password</label>
                {/* <label className="text-right p-0" style={{ color: "#A1A1A1" }}>
                  Forgot Password?
                </label> */}
              </div>
              <div className="password-input-wrapper">
                <input
                  type={ showPassword ? "text" : "password" }
                  className="form-control"
                  placeholder="Password"
                  name="password"
                  value={ credentials.password }
                  onChange={ handleInputChange }
                // maxLength={8}
                />
                <span
                  className="password-toggle"
                  onClick={ handleTogglePassword }
                >
                  <FontAwesomeIcon icon={ showPassword ? faEye : faEyeSlash } />
                </span>
              </div>
            </div>

            {/* <div className="remember-me">
              <ReCAPTCHA
               ref={captchaRef}
                sitekey="6LdRn8UpAAAAADK6zJMzhFZg45cskLczUtAzxZ70"
                onChange={handleCaptchaChange}
              />
            </div>
            <div className="form-group">
             
              {captchaError && <p className="text-danger">{captchaError}</p>}
            
            </div> */}
            <div className="remember-me">
              <input type="checkbox" style={ { marginRight: "10px" } } />
              <label style={ { display: "contents" } }>Remember Me</label>
            </div>
            <button
              type="submit"
              // className="btn btn-block"
              data-sitekey="6LdRn8UpAAAAADK6zJMzhFZg45cskLczUtAzxZ70"
              // style={{ backgroundColor: "#e74c3c", color: "#fff" }}
              className={ `btn btn-block ${ isProd ? "btn-blue" : "btn-red" } ` }
              disabled={ isLoading }
            >
              { isLoading ? "Loading..." : "SIGN IN" }
            </button>
          </form>
          { isLoading && <Loader /> }
          {/* <p className="mt-4">Don't have an account yet? Sign up here</p> */ }
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
